var exports = {
  "TH": "nodeTitle-U0t4W",
  "iQ": "wikiPreviewContent-U0t4W",
  "ks": "wikiPreviewExpanded-U0t4W",
  "z2": "wikiPreviewToggle-U0t4W",
};

module.exports = exports;
